import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '../../../../widgets/entry-components/alert/services/alert.service';
import { LoadingService } from '../../../../widgets/entry-components/loading/services/loading.service';
import { ToastService } from '../../../../widgets/entry-components/toast/services/toast.service';
import { AbstractService } from '../../services/abstract.service';
import { Location } from '@angular/common';

@Component({
  selector: 'inc-abstract-page-add',
  template: ''
})
export class AbstractPageAddComponent<T> implements OnInit, OnDestroy {
  dataFromRoute: T;
  dataRoute: Subscription;
  dataForUpdate: T;
  dataNameStr: string;
  title: string;

  constructor(
    private service: AbstractService<T>, private loadingService: LoadingService, protected alertService: AlertService,
    private toastService: ToastService, private activatedRoute: ActivatedRoute, private location: Location
  ) {
  }

  ngOnInit() {
    this.getDataFromRouter();
  }

  ngOnDestroy() {
    if (this.dataRoute) {
      this.dataRoute.unsubscribe();
    }
    localStorage.removeItem(this.dataNameStr);
  }

  getDataFromRouter() {
    this.dataRoute = this.activatedRoute.paramMap.subscribe(() => {
      const data: T = window.history.state.parameter;
      if (data) {
        localStorage.setItem(this.dataNameStr, JSON.stringify(data));
      }
      this.dataForUpdate = JSON.parse(localStorage.getItem(this.dataNameStr));
      if (this.dataForUpdate) {
        this.title = 'MODIFICATION_' + this.dataNameStr.toUpperCase();
      }
    });
  }

  save(data: T) {
    if (this.service) {
      this.loadingService.presentLoading('ADD_' + this.dataNameStr.toUpperCase()).then(() => {
        this.service.add(data).then(
          () => {
            this.toastService.presentToast('ADD_' + this.dataNameStr.toUpperCase() + '_SUCCESS');
          }, () => {
            this.alertService.presentError('ADD_' + this.dataNameStr.toUpperCase() + '_UNSUCCESSFULL');
          }).finally(() => {
            this.loadingService.dismissLoading();
            this.location.back();
          });
      });
    }
  }

  update(data: T) {
    if (this.service) {
      this.loadingService.presentLoading('MODIFICATION_' + this.dataNameStr.toUpperCase()).then(() => {
        this.service.update(data).then(
          () => {
            localStorage.setItem(this.dataNameStr, JSON.stringify(data));
            this.toastService.presentToast('UPDATE_' + this.dataNameStr.toUpperCase() + '_SUCCESS');
          }, () => {
            this.alertService.presentError('UPDATE_' + this.dataNameStr.toUpperCase() + '_UNSUCCESSFULL');
          }).finally(() => {
            this.loadingService.dismissLoading();
            this.location.back();
          });
      });
    }
  }

}
